import { Mongo } from './mongo';

export interface Purpose {
  _id: Mongo.ObjectId;
  title: string;
  description: string;
  effectiveFrom: Date | string
  deletedFrom?: Date | string
}

export interface PlannedPurpose extends Purpose {
  actions: PlannedPurpose.Action[];
}

export namespace PlannedPurpose {
  export interface Action {
    _id: Mongo.ObjectId;
    title: string;
    description: string;
    kpis: (QuantitativeKpi | QualitativeKpi)[];
  }

  export abstract class Kpi {
    constructor(public title: string, public description: string) {}

    abstract getResult(): number;
  }

  export enum KpiType {
    QUANTITATIVE = 1,
    QUALITATIVE = 2,
  }

  export class QuantitativeKpi extends Kpi {
    public target: number;
    public readonly type = KpiType.QUANTITATIVE;
    constructor(
      title: string,
      description: string,
      public progress: number,
      target: number
    ) {
      super(title, description);
        this.target = target;
    }

    getResult(): number {
      if (this.target && this.target !== 0) {
        const res = (100 * this.progress) / this.target;
        // round
        return Math.round((res + Number.EPSILON) * 100) / 100;
      }
      return 0;
    }
  }

  export class QualitativeKpi extends Kpi {
    public readonly type = KpiType.QUALITATIVE;
    public readonly target: number = 100;
    constructor(title: string, description: string, public progress: number) {
      super(title, description);
    }

    getResult(): number {
      const res = (100 * this.progress) / this.target;
      return Math.round((res + Number.EPSILON) * 100) / 100;
    }
  }
}
